export { ScopeTrust } from './scope-trust';
export { ScopeTrustCmd } from './scope-trust.cmd';
